const Attributes = [
  {
    path: '/ecommerce/inventory/attributes-groups',
    name: 'base-attributes',
    component: () => import(/* webpackChunkName: "attribute-base" */ './AttributesView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Attributes Group',
          path: '/ecommerce/inventory/attributes-groups',
        },
      ],
    },
    children: [
      {
        path: '/',
        name: 'all-attributes-groups',
        component: () => import(/* webpackChunkName: "attribute-groups" */ './components/AttributeGroup.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Attributes Group',
              path: '/inventory/attributes-groups',
            },
          ],
        },
      },
    ],
  },
];

export default Attributes;
